import { getIsTravelApp } from "@capone/common";
import { History } from "history";
import queryStringParser from "query-string";

export interface ICarsParsedQuery {
  isTravelApp?: boolean;
  bookStep?: string;
}

export const parseQueryFromString = (queryString: string): ICarsParsedQuery => {
  const { isTravelApp } = getIsTravelApp(queryString);
  const parsedQueryStringPrimitive = queryStringParser.parse(queryString);
  return {
    isTravelApp,
    bookStep: parsedQueryStringPrimitive.bookStep as string,
  };
};

export const parseQueryString = (history: History): ICarsParsedQuery | null => {
  const queryString = history?.location?.search || "";
  return queryString ? parseQueryFromString(queryString) : null;
};
